__turbopack_context__.v({
  "Landing__27": "tiny-footer-module__VDXyEq__Landing__27",
  "tinyFooter": "tiny-footer-module__VDXyEq__tinyFooter",
});
